module.exports = __webpack_public_path__ + "90f5004c8bfb37fd2a4c81daff1562ea.png";